import {
  Box,
  FormHelperText,
  Typography,
  Grid,
  IconButton,
  InputAdornment,
  LinearProgress,
  SvgIcon,
} from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import WhatsAppButton from "../../Components/UI/WhatsAppButton";
import {
  CustomTextField,
  CountryCodeSelect,
  StyledMenuItem,
  Button,
  Spinner,
} from "../../Components/UI";
import "./Registration.scss";
import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import CheckIcon from "@mui/icons-material/Check";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { useFormik } from "formik";
import * as yup from "yup";
import { connect } from "react-redux";
import {
  CheckRegisteredEmailAndMobile,
  CheckRegisteredUser,
  CreateUser,
} from "../../Store/Actions/userActionCreator";
import EmailOtpVerificationModal from "../../Components/Modals/ModalContexts/EmailOtpVerificationModal";
import MobileOtpVerificationModal from "../../Components/Modals/ModalContexts/MobileOtpVerificationModal";
import { showMessage } from "../../Utils/helper";
import {
  DEFAULT_COUNTRY_CODE,
  getMobileError,
  getMobileLabel,
  getOtpChannel,
} from "../../Utils/mobile";
import { USER_ROLE_ENUM } from "../../Utils/constants";
import { DatePicker, LocalizationProvider } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { useConfirm } from "../../Components/ConfirmationModal";

// Material Design Icons "face-man" / "face-woman" — same glyphs as the mobile app
const FaceManIcon = (props) => (
  <SvgIcon {...props}>
    <path d="M9,11.75A1.25,1.25 0 0,0 7.75,13A1.25,1.25 0 0,0 9,14.25A1.25,1.25 0 0,0 10.25,13A1.25,1.25 0 0,0 9,11.75M15,11.75A1.25,1.25 0 0,0 13.75,13A1.25,1.25 0 0,0 15,14.25A1.25,1.25 0 0,0 16.25,13A1.25,1.25 0 0,0 15,11.75M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20C7.59,20 4,16.41 4,12C4,11.71 4,11.42 4.05,11.14C6.41,10.09 8.28,8.16 9.26,5.77C11.07,8.33 14.05,10 17.42,10C18.2,10 18.95,9.91 19.67,9.74C19.88,10.45 20,11.21 20,12C20,16.41 16.41,20 12,20Z" />
  </SvgIcon>
);
const FaceWomanIcon = (props) => (
  <SvgIcon {...props}>
    <path d="M13.75 13C13.75 12.31 14.31 11.75 15 11.75S16.25 12.31 16.25 13 15.69 14.25 15 14.25 13.75 13.69 13.75 13M22 12V22H2V12C2 6.5 6.5 2 12 2S22 6.5 22 12M4 12C4 16.41 7.59 20 12 20S20 16.41 20 12C20 11.21 19.88 10.45 19.67 9.74C18.95 9.91 18.2 10 17.42 10C14.05 10 11.07 8.33 9.26 5.77C8.28 8.16 6.41 10.09 4.05 11.14C4 11.42 4 11.71 4 12M9 14.25C9.69 14.25 10.25 13.69 10.25 13S9.69 11.75 9 11.75 7.75 12.31 7.75 13 8.31 14.25 9 14.25Z" />
  </SvgIcon>
);

const getMinAge = (gender) => (gender === "MALE" ? 21 : 18);
const getMaxDob = (gender) => moment().subtract(getMinAge(gender), "years");

const SUB_STEPS = [
  {
    title: "Tell us about the Vadhu / Vara",
    fields: ["gender", "firstName", "lastName", "dateOfBirth", "profileCreatedBy"],
  },
  {
    title: "How can we reach you?",
    fields: ["countryCode", "mobileNumber", "emailId"],
  },
  {
    title: "Secure your account",
    fields: ["password", "cpassword"],
  },
];

const getPasswordStrength = (pwd = "") => {
  let score = 0;
  if (pwd.length >= 4) score++;
  if (pwd.length >= 8) score++;
  if (/[A-Z]/.test(pwd) && /[a-z]/.test(pwd)) score++;
  if (/\d/.test(pwd) && /[^A-Za-z0-9]/.test(pwd)) score++;
  const labels = ["Too short", "Weak", "Fair", "Good", "Strong"];
  const colors = ["#d5dbe6", "#ef4444", "#f59e0b", "#3b82f6", "#10b981"];
  return { score, label: pwd ? labels[score] : "", color: colors[score] };
};

function Register({
  dispatchCreateUser,
  dispatchCheckRegisteredUser,
  dispatchCheckRegisteredEmailAndMobile,
  ...props
}) {
  const [openEmailOtpModal, setOpenEmailOtpModal] = useState(false);
  const [openMobileOtpModal, setOpenMobileOtpModal] = useState(false);
  const [isEmailFocused, setIsEmailFocused] = useState(false);
  const [isMobileFocused, setIsMobileFocused] = useState(false);
  const [routeData, setRouteData] = useState({});
  const [loading, toggleLoading] = useState(false);
  const [subStep, setSubStep] = useState(0);
  const [showPassword, setShowPassword] = useState(false);

  const ConfirmationModal = useConfirm();

  // let emailIdSchemaValided = false;
  const emailIdSchema = yup
    .string("Invalid Email")
    .email("Enter a valid email")
    .trim()
    .required("Email cannot be empty");

  const mobileSchema = yup
    .string("Invalid alternate contact no.")
    .trim()
    .required("Mobile number cannot be empty");
  const validationSchema = yup.object({
    firstName: yup
      .string("Invalid first Name")
      .trim()
      .required("First Name cannot be empty")
      .matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed for this field ")
      .min(3)
      .max(15),
    lastName: yup
      .string("Invalid last Name")
      .trim()
      .required("Last Name cannot be empty")
      .matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed for this field ")
      .min(3)
      .max(15),
    mobileNumber: mobileSchema
      .test("mobileFormat", function (value) {
        const error = getMobileError(this.parent.countryCode, value);
        return error ? this.createError({ message: error }) : true;
      })
      .test("mobileNumber", "Mobile Number is already registered.", function (value) {
        const isValid = !getMobileError(this.parent.countryCode, value);
        return new Promise((resolve) => {
          if (!!value && isValid && !!isMobileFocused) {
            dispatchCheckRegisteredUser(
              {
                userId: value,
              },
              (resp) => {
                resolve(!!resp?.status);
              },
              (err) => {
                showMessage(err ?? "Server Error", "error");
                resolve(false);
              }
            );
          } else {
            resolve(true);
          }
        });
      })
      .required("Mobile Number cannot be empty"),
    emailId: emailIdSchema.test(
      "emailId",
      "email is already registered.",
      (value) => {
        return new Promise((resolve, reject) => {
          emailIdSchema.isValid(value).then((isValid) => {
            if (!!value && isValid && !!isEmailFocused) {
              dispatchCheckRegisteredUser(
                {
                  userId: value,
                },
                (resp) => {
                  if (!resp?.status) {
                    resolve(false);
                    // resolve(!!resp?.status);
                    // emailIdSchemaValided = !!resp?.status;
                  } else {
                    resolve(true);
                  }
                },
                (err) => {
                  showMessage(err ?? "Server Error", "error");
                  resolve(false);
                }
              );
            } else {
              // resolve(emailIdSchemaValided);
              resolve(true);
            }
          });
        });
      }
    ),
    gender: yup.string("").trim().required("Gender cannot be empty"),
    password: yup
      .string()
      .min(4)
      .test("password", "Both password need to be the same", function (value) {
        return this.parent.cpassword === value;
      })
      .required("Password cannot be empty"),
    cpassword: yup
      .string()
      .test("cpassword", "Both password need to be the same", function (value) {
        return this.parent.password === value;
      })
      .required("Confirm password cannot be empty")
      .min(4),
    dateOfBirth: yup
      .string()
      .trim()
      .test("dateOfBirth", function (value) {
        const minAge = getMinAge(this.parent.gender);
        if (moment(value).isAfter(getMaxDob(this.parent.gender))) {
          return this.createError({
            message: `${
              minAge === 21 ? "Boys" : "Girls"
            } must be at least ${minAge} years old`,
          });
        }
        return true;
      })
      .nullable()
      .required("Date Of Birth cannot be empty"),
    profileCreatedBy: yup
      .string()
      .trim()
      .required("Profile created by cannot be empty"),
  });

  const formik = useFormik({
    validateOnBlur: true,
    validateOnChange: true,
    initialValues: {
      gender: "",
      firstName: "",
      lastName: "",
      countryCode: DEFAULT_COUNTRY_CODE,
      mobileNumber: "",
      emailId: "",
      password: "",
      cpassword: "",
      dateOfBirth: "",
      profileCreatedBy: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values, err) => {
      const payload = {
        ...values,
        dateOfBirth: moment(values?.dateOfBirth).format("DD/MM/YYYY"),
      };
      dispatchCheckRegisteredEmailAndMobile(
        {
          mobileNumber: values?.mobileNumber,
          emailId: values?.emailId,
        },
        (resp) => {
          toggleLoading(false);
          if (!!resp?.status) {
            ConfirmationModal({
              description: `OTP will be sent on ${payload?.emailId} and +${payload?.countryCode} ${payload?.mobileNumber} (via ${getOtpChannel(payload?.countryCode)}) for verification.`,
            })
              .then(() => {
                toggleLoading(true);
                dispatchCreateUser(
                  payload,
                  (resp) => {
                    if (!!resp?.status) {
                      toggleLoading(false);
                      if (!resp?.result?.emailVerified) {
                        setOpenEmailOtpModal(true);
                      } else if (!resp?.result?.mobileVerified) {
                        setOpenMobileOtpModal(true);
                      } else if (
                        !!resp?.result &&
                        resp?.result?.roles[resp?.result?.roles?.length - 1]
                          ?.authority === USER_ROLE_ENUM.ROLE_NORMAL_USER
                      ) {
                        props.history.push("/register/basic");
                      } else {
                        props.history.push("/");
                      }
                    } else {
                      toggleLoading(false);
                      showMessage(resp?.result, "error");
                    }
                  },
                  (err) => {
                    toggleLoading(false);
                  }
                );
              })
              .catch(() => {
                toggleLoading(false);
              });
          } else {
            showMessage(resp?.result, "error");
          }
        },
        (err) => {
          toggleLoading(false);
        }
      );
    },
  });

  useEffect(() => {
    const data = props?.location?.state ?? null;
    setRouteData(data ?? {});
    if (!!data && !data?.emailVerified) {
      setOpenEmailOtpModal(true);
    } else if (!!data && !data?.mobileVerified) {
      setOpenMobileOtpModal(true);
    }
  }, [props?.location?.state]);

  const isLastSubStep = subStep === SUB_STEPS.length - 1;

  const goNext = async () => {
    const fields = SUB_STEPS[subStep].fields;
    formik.setTouched(
      {
        ...formik.touched,
        ...Object.fromEntries(fields.map((f) => [f, true])),
      },
      false
    );
    const errs = await formik.validateForm();
    if (fields.every((f) => !errs[f])) {
      setSubStep((v) => v + 1);
    }
  };

  const onFormSubmit = (e) => {
    if (!isLastSubStep) {
      e.preventDefault();
      goNext();
    } else {
      e.preventDefault();
      submitWithStepCheck();
    }
  };

  const submitWithStepCheck = async () => {
    const errs = await formik.validateForm();
    const badStep = SUB_STEPS.findIndex((st) => st.fields.some((f) => errs[f]));
    if (badStep !== -1 && badStep !== subStep) {
      formik.setTouched(
        {
          ...formik.touched,
          ...Object.fromEntries(
            SUB_STEPS[badStep].fields.map((f) => [f, true])
          ),
        },
        false
      );
      setSubStep(badStep);
      showMessage("Please fix the highlighted details to continue", "error");
      return;
    }
    formik.submitForm();
  };

  const fieldProps = (name) => ({
    id: name,
    name,
    value: formik.values[name],
    onChange: formik.handleChange,
    onBlur: formik.handleBlur,
    error: formik.touched[name] ? Boolean(formik.errors[name]) : false,
    helperText: formik.touched[name] && formik.errors[name],
    className: "custom_text_box",
    isRequired: true,
    variant: "outlined",
  });

  // Move a too-recent date of birth back to the latest allowed one when gender changes
  useEffect(() => {
    const dob = formik.values.dateOfBirth;
    const maxDob = getMaxDob(formik.values.gender);
    if (!!dob && moment(dob).isAfter(maxDob)) {
      formik.setFieldValue("dateOfBirth", maxDob, true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values.gender]);

  const strength = getPasswordStrength(formik.values.password);

  const genderWord =
    formik.values.gender === "MALE"
      ? "Boy's "
      : formik.values.gender === "FEMALE"
      ? "Girl's "
      : "";

  return (
    <Box className="register_verify">
      <WhatsAppButton />
      <Typography variant="h4" className="reg-heading">
        Welcome to JSPN Vadhu Vara Samyojana
      </Typography>
      <Typography className="reg-subheading">
        You are a few steps away from being a registered member. Please enter
        your correct Email and Mobile Number, we will verify them next.
      </Typography>
      <div className="reg-note">
        Please make sure you are seeking for First Marriage only.
      </div>

      <div className="reg-substeps">
        <div className="reg-substeps-meta">
          <span>
            Step {subStep + 1} of {SUB_STEPS.length}
          </span>
          <span>{SUB_STEPS[subStep].title}</span>
        </div>
        <LinearProgress
          variant="determinate"
          value={((subStep + 1) / SUB_STEPS.length) * 100}
          className="reg-progress"
        />
      </div>

      <Spinner loading={loading}>
        <form onSubmit={onFormSubmit} noValidate>
          <div className="reg-panel" key={subStep}>
            {subStep === 0 && (
              <Grid container columnSpacing={2}>
                <Grid item xs={12}>
                  <Typography className="reg-label" id="gender-label">
                    Who are you registering? <span className="req">*</span>
                  </Typography>
                  <div
                    className="gender-cards"
                    role="radiogroup"
                    aria-labelledby="gender-label"
                    aria-required="true"
                    onKeyDown={(e) => {
                      const vals = ["MALE", "FEMALE"];
                      const i = vals.indexOf(formik.values.gender);
                      let n = null;
                      if (e.key === "ArrowRight" || e.key === "ArrowDown")
                        n = vals[(i + 1) % 2];
                      if (e.key === "ArrowLeft" || e.key === "ArrowUp")
                        n = vals[(i + 1) % 2];
                      if (n) {
                        e.preventDefault();
                        formik.setFieldValue("gender", n, true);
                        formik.setFieldTouched("gender", true, false);
                        e.currentTarget
                          .querySelector(`[data-value="${n}"]`)
                          ?.focus();
                      }
                    }}
                  >
                    {[
                      {
                        value: "MALE",
                        label: "Vara",
                        hint: "Groom · Boy",
                        Icon: FaceManIcon,
                      },
                      {
                        value: "FEMALE",
                        label: "Vadhu",
                        hint: "Bride · Girl",
                        Icon: FaceWomanIcon,
                      },
                    ].map(({ value, label, hint, Icon }) => (
                      <button
                        type="button"
                        key={value}
                        role="radio"
                        data-value={value}
                        tabIndex={
                          formik.values.gender === value ||
                          (!formik.values.gender && value === "MALE")
                            ? 0
                            : -1
                        }
                        aria-checked={formik.values.gender === value}
                        className={`gender-card ${
                          formik.values.gender === value ? "selected" : ""
                        }`}
                        onClick={() => {
                          formik.setFieldValue("gender", value, true);
                          formik.setFieldTouched("gender", true, false);
                        }}
                      >
                        <span className="gender-icon">
                          <Icon fontSize="large" />
                        </span>
                        <span className="gender-title">{label}</span>
                        <small className="gender-sub">{hint}</small>
                        <span className="gender-radio" aria-hidden="true">
                          {formik.values.gender === value && (
                            <CheckIcon sx={{ fontSize: 14 }} />
                          )}
                        </span>
                      </button>
                    ))}
                  </div>
                  {formik.values.gender && (
                    <Typography className="reg-hint" sx={{ mt: 1 }}>
                      {formik.values.gender === "MALE"
                        ? "You are registering a Vara and looking for a Vadhu"
                        : "You are registering a Vadhu and looking for a Vara"}
                    </Typography>
                  )}
                  <FormHelperText
                    error
                    sx={{ minHeight: 20, marginBottom: 1 }}
                  >
                    {!!formik.touched.gender && formik.errors.gender}
                  </FormHelperText>
                </Grid>
                {formik.values.gender && (
                  <Grid item xs={12}>
                    <Typography className="reg-label">
                      Enter the details of the{" "}
                      {formik.values.gender === "MALE"
                        ? "Vara (Boy)"
                        : "Vadhu (Girl)"}{" "}
                      below
                    </Typography>
                  </Grid>
                )}
                <Grid item xs={12} md={6}>
                  <CustomTextField
                    label={`${genderWord}First Name`}
                    {...fieldProps("firstName")}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <CustomTextField
                    label={`${genderWord}Last Name`}
                    {...fieldProps("lastName")}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      disableFuture
                      minDate={moment("1977-01-01").toDate()}
                      disableCloseOnSelect={false}
                      maxDate={getMaxDob(formik.values.gender).toDate()}
                      inputFormat="dd/MM/yyyy"
                      openTo="year"
                      views={["year", "month", "day"]}
                      value={
                        !!formik.values.dateOfBirth
                          ? moment(formik.values.dateOfBirth)?.valueOf() > 0
                            ? formik.values.dateOfBirth
                            : null
                          : null
                      }
                      onChange={(e) => {
                        if (e !== null) {
                          formik.setFieldValue("dateOfBirth", moment(e), true);
                        }
                      }}
                      onBlur={formik.handleBlur}
                      renderInput={(params) => (
                        <CustomTextField
                          {...params}
                          variant={"outlined"}
                          label={`${genderWord}Date of Birth`}
                          id="dateOfBirth"
                          name="dateOfBirth"
                          className="custom_text_box"
                          error={
                            formik.touched.dateOfBirth
                              ? Boolean(formik.errors.dateOfBirth)
                              : false
                          }
                          helperText={
                            formik.touched.dateOfBirth &&
                            formik.errors.dateOfBirth
                          }
                          isRequired={true}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={12} md={6}>
                  <CustomTextField
                    label="Profile Created by"
                    {...fieldProps("profileCreatedBy")}
                    select
                    fullWidth={true}
                  >
                    <StyledMenuItem value={"Self"}>Self</StyledMenuItem>
                    <StyledMenuItem value={"Father"}>Father</StyledMenuItem>
                    <StyledMenuItem value={"Mother"}>Mother</StyledMenuItem>
                    <StyledMenuItem value={"Sibling"}>Sibling</StyledMenuItem>
                    <StyledMenuItem value={"Relative"}>Relative</StyledMenuItem>
                  </CustomTextField>
                </Grid>
              </Grid>
            )}

            {subStep === 1 && (
              <Grid container columnSpacing={2}>
                <Grid item xs={12}>
                  <Box style={{ display: "flex", gap: "8px" }}>
                    <CountryCodeSelect
                      value={formik.values.countryCode}
                      onChange={formik.handleChange}
                      variant={"outlined"}
                      style={{ width: 105, minWidth: 105 }}
                    />
                    <CustomTextField
                      label={getMobileLabel(formik.values.countryCode)}
                      {...fieldProps("mobileNumber")}
                      value={formik.values.mobileNumber.trim()}
                      onChange={(e) => {
                        e.target.value = e.target.value.trim();
                        formik.handleChange(e);
                      }}
                      onBlur={(e) => {
                        setIsMobileFocused(false);
                        formik.handleBlur(e);
                      }}
                      onFocus={() => {
                        setIsMobileFocused(true);
                      }}
                      style={{ flex: 1 }}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <CustomTextField
                    label="Email-ID"
                    {...fieldProps("emailId")}
                    value={formik.values.emailId.trim()}
                    onChange={(e) => {
                      e.target.value = e.target.value.trim();
                      formik.handleChange(e);
                    }}
                    onBlur={(e) => {
                      setIsEmailFocused(false);
                      formik.handleBlur(e);
                    }}
                    onFocus={() => {
                      setIsEmailFocused(true);
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <div className="reg-hint">
                    We will send a one-time password to both to verify them.
                  </div>
                </Grid>
              </Grid>
            )}

            {subStep === 2 && (
              <Grid container columnSpacing={2}>
                <Grid item xs={12}>
                  <CustomTextField
                    label="Password"
                    {...fieldProps("password")}
                    InputProps={{
                      type: showPassword ? "text" : "password",
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={() => setShowPassword((v) => !v)}
                            edge="end"
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  <div className="strength">
                    <div className="strength-bars">
                      {[1, 2, 3, 4].map((i) => (
                        <span
                          key={i}
                          style={{
                            background:
                              i <= strength.score ? strength.color : "#e5e7ef",
                          }}
                        />
                      ))}
                    </div>
                    <span style={{ color: strength.color }}>
                      {strength.label}
                    </span>
                  </div>
                </Grid>
                <Grid item xs={12}>
                  <CustomTextField
                    label="Confirm Password"
                    {...fieldProps("cpassword")}
                    InputProps={{
                      type: showPassword ? "text" : "password",
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <div className="reg-hint">
                    By clicking on VERIFY ME, you agree to our{" "}
                    <a
                      href="/terms-and-conditions"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Terms &amp; Conditions
                    </a>
                  </div>
                </Grid>
              </Grid>
            )}
          </div>

          <div className="reg-actions">
            {subStep > 0 && (
              <Button
                variant="outlined"
                size="large"
                type="button"
                className="reg-back"
                startIcon={<ArrowBackOutlinedIcon fontSize="small" />}
                onClick={() => setSubStep((v) => v - 1)}
              >
                Back
              </Button>
            )}
            <Button
              variant="contained"
              size="large"
              type="submit"
              className="reg-next"
              endIcon={<ArrowForwardOutlinedIcon fontSize="small" />}
            >
              {isLastSubStep ? "Verify Me" : "Continue"}
            </Button>
          </div>
        </form>
      </Spinner>

      {!!openEmailOtpModal && (
        <EmailOtpVerificationModal
          open={openEmailOtpModal}
          data={{
            emailId: formik?.values?.emailId,
            ...routeData,
            validateNewOTP: false,
          }}
          onClose={() => {
            setOpenEmailOtpModal(false);
          }}
          next={() => {
            setOpenEmailOtpModal(false);
            setOpenMobileOtpModal(true);
          }}
        />
      )}
      {!!openMobileOtpModal && (
        <MobileOtpVerificationModal
          open={openMobileOtpModal}
          data={{
            mobileNumber: formik?.values?.mobileNumber,
            countryCode: formik?.values?.countryCode,
            ...routeData,
          }}
          onClose={() => {
            setOpenMobileOtpModal(false);
          }}
        />
      )}
    </Box>
  );
}

const mapStateToProps = (state) => ({
  user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
  dispatchCreateUser: (payload, onSuccess, onError) =>
    dispatch(CreateUser(payload, onSuccess, onError)),
  dispatchCheckRegisteredUser: (payload, onSuccess, onError) =>
    dispatch(CheckRegisteredUser(payload, onSuccess, onError)),
  dispatchCheckRegisteredEmailAndMobile: (payload, onSuccess, onError) =>
    dispatch(CheckRegisteredEmailAndMobile(payload, onSuccess, onError)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Register);

export const HorizontalLine = () => <hr className="reg-divider" />;

export const HeadTitle = ({ title, subTitle, subTitleColor }) => (
  <div className="reg-section-title">
    <span className="dot" />
    <div>
      <Typography className="title">{title}</Typography>
      {!!subTitle && (
        <Typography
          className="subtitle"
          style={subTitleColor ? { color: subTitleColor } : undefined}
        >
          {subTitle}
        </Typography>
      )}
    </div>
  </div>
);
